import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import {
  MenuOpen as MenuOpenIcon,
  Menu as MenuIcon,
  Search as SearchIcon,
  Print as PrintIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
  FileDownload as FileDownloadIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,  
  Star as StarIcon,
  StarBorder as StarBorderIcon,  
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { setMyMenuData } from "@/store/userSlice";

// 공통코드
import { useApiUtil } from "@/utils/apiUtil";

// ✅ 공통 버튼 스타일
const commonButtonStyle = {
  height: 30,
  minHeight: "unset",
  padding: "2px 10px",
  fontSize: "12px",
  //fontWeight: "bold",
  alignItems: "center",
  //backgroundColor: "#22A2FF",
  //color: "#fff",
  //border: "1px solid #1890FF",
  borderRadius: "5px",
  boxShadow: "none",
};

const FrameTitle = ({
  selectMenuId,
  title,
  permissions = {},
  onClickButton,
  isSidebarOpen,
  toggleSidebar,
  addBtn = []
}) => {

  const dispatch = useDispatch();

  const { gfnCallApi } = useApiUtil();

  const [addBtnList, setAddBtnList] = useState([]);
  const menuData = useSelector((state) => state.user.menuData);
  const myMenuData = useSelector((state) => state.user.myMenuData);
  
  const [isFavorite, setIsFavorite] = useState(false);
  const toBool = (v) => v === 1 || v === true;
  
  const {
    print = 0,
    excel = 0,
    select = 0,
    add = 0,
    save = 0,
    del = 0,
    prgmId,
    permId,
    menuId,
    sytmFlagCd,
  } = permissions;

  // 즐겨찾기처리
  const handleFavoriteToggle = async () => {
    if(!selectMenuId || selectMenuId === "") return;
    const _rowType_ = isFavorite?"DELETE":"INSERT";
    const result = await gfnCallApi({
      method: "post",
      url: "addMyMenu",
      data: {
        _rowType_: _rowType_,
        MENU_ID: selectMenuId,
      },
    });
    if (result.code === 0 && result.result > 0) {
      let nextMyMenuData;

      if (isFavorite) {
        // 삭제
        nextMyMenuData = myMenuData.filter(
          (m) => m.MENU_ID !== selectMenuId
        );
      } else {
        // 추가
        const selMenu = menuData.filter(
          (m) => m.MENU_ID === selectMenuId
        );
        nextMyMenuData = [
          ...myMenuData,
          {
            MENU_ID: selectMenuId,
            MENU_NM: selMenu[0].MENU_NM,
            PRGM_ID: selMenu[0].PRGM_ID,
            MODULE_CD: selMenu[0].MODULE_CD,
          },
        ];
      }

      // Redux 업데이트
      dispatch(setMyMenuData(nextMyMenuData));

      // 로컬 상태 동기화
      setIsFavorite(!isFavorite);
    }  
  };

  const handleClick = (action) => {
    if (onClickButton) onClickButton(action);
  };

  const searchBtnList = async (menuId, prgmId) => {
    try {
      setAddBtnList(addBtn);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (menuId && prgmId) searchBtnList(menuId, prgmId);
  }, [menuId, prgmId, permId, sytmFlagCd]);

  useEffect(() => {
    if(!selectMenuId || selectMenuId === "") return;
    const exists = myMenuData.some(item => item.MENU_ID === selectMenuId);
    setIsFavorite(exists);
  }, [myMenuData, selectMenuId]);  

  const fixedButtons = [
    {
      key: "print",
      label: "출력",
      icon: <PrintIcon sx={{ color: "#fff", width: 15, height: 15 }}/>,
      sx: {
        backgroundColor: "#004C8F",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#003A6D",
        },
      },   
      show: toBool(print), 
    },    
    {
      key: "excel",
      label: "엑셀",
      icon: <FileDownloadIcon sx={{ color: "#fff", width: 15, height: 15 }}/>,
      color: "success",
      show: toBool(excel),
      sx: {
        backgroundColor: "#004C8F",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#003A6D",
        },
      },           
    },
    /* 업무영역으로 이동
    {
      key: "select",
      label: "조회",
      icon: <SearchIcon sx={{ color: "#fff" }}/>,
      bgColor: "#22A2FF",
      show: toBool(select),
      sx: {
        backgroundColor: "#22A2FF",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#1b8fe0",
        },
      },      
    },
    */
    {
      key: "add",
      label: "추가",
      icon: <AddIcon sx={{ color: "#fff", width: 15, height: 15 }}/>,
      sx: {
        backgroundColor: "#004C8F",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#003A6D",
        },
      },   
      show: toBool(add),
    },
    {
      key: "del",
      label: "삭제",
      icon: <DeleteIcon sx={{ color: "#fff", width: 15, height: 15 }}/>,
      color: "error",
      sx: {
        backgroundColor: "#004C8F",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#003A6D",
        },
      },      
      show: toBool(del),
    },
    {
      key: "save",
      label: "저장",
      icon: <SaveIcon sx={{ color: "#fff", width: 15, height: 15 }}/>,
      color: "success",
      sx: {
        backgroundColor: "#004C8F",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#003A6D",
        },
      },           
      show: toBool(save),
    },
  ];

  const fixedButtons_ = [
    {
      key: "excel",
      label: "엑셀",
      icon: <FileDownloadIcon sx={{ color: "#fff", width: 15, height: 15 }}/>,
      color: "success",
      show: toBool(excel),
    },
    {
      key: "select",
      label: "조회",
      icon: <SearchIcon sx={{ color: "#fff", width: 15, height: 15 }}/>,
      color: "primary",
      show: toBool(select),
    },
    {
      key: "add",
      label: "추가",
      icon: <AddIcon sx={{ color: "#fff", width: 15, height: 15 }}/>,
      color: "primary",
      show: toBool(add),
    },
    {
      key: "del",
      label: "삭제",
      icon: <DeleteIcon sx={{ color: "#d32f2f" }}/>,
      color: "error",
      show: toBool(del),
    },
    {
      key: "save",
      label: "저장",
      icon: <SaveIcon sx={{ color: "#2e7d32" }}/>,
      color: "success",
      show: toBool(save),
    },
  ];

  return (
    <Box>
      <Box
        sx={{
          backgroundColor: "#ffffff",
          borderTop: "1px solid #e0e0e0",
          borderBottom: "1px solid #e0e0e0",
          padding: "8px 16px",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            {/* ✅ 사이드바 접기/펼치기 전용 아이콘 (맨 좌측) */}
            <IconButton
              onClick={toggleSidebar}
              size="small"
              sx={{
                width: 28,
                height: 28,
                borderRadius: "50%",
                border: "1px solid #e0e0e0",
                backgroundColor: "#f9fafb",
                "&:hover": {
                  backgroundColor: "#eef2f7",
                },
              }}
            >
              {isSidebarOpen ? (
                <ChevronLeftIcon fontSize="small" />
              ) : (
                <ChevronRightIcon fontSize="small" />
              )}
            </IconButton>

            {/* 🔹 기존 메뉴 아이콘 (다른 용도) */}
            { selectMenuId !== "Home" && (
            <Tooltip title={isFavorite ? "즐겨찾기 해제" : "즐겨찾기 등록"}>
              <IconButton
                size="small"
                onClick={handleFavoriteToggle}
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#fff",
                  "&:hover": {
                    backgroundColor: "#fffbe6",
                  },
                }}
              >
                {isFavorite ? (
                  <StarIcon
                    fontSize="small"
                    sx={{ color: "#FFC107" }}   // ⭐ 노란색
                  />
                ) : (
                  <StarBorderIcon
                    fontSize="small"
                    sx={{ color: "#9e9e9e" }}   // ☆ 회색 테두리
                  />
                )}
              </IconButton>
            </Tooltip>
            )}
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, fontSize: "14px" }}
            >
              {title}
            </Typography>
          </Box>


          <Box sx={{ display: "flex", gap: "5px" }}>
            {addBtnList
              .filter((btn) => btn.usedYn === "1")
              .sort((a, b) => a.sortOrdr - b.sortOrdr)
              .map((btn) => (
                <Button
                  key={btn.bttnId}
                  variant="outlined"
                  sx={commonButtonStyle}
                  onClick={() => handleClick(btn.bttnId)}
                >
                  {btn.bttnNm}
                </Button>
              ))}

            {fixedButtons.map(
              ({ key, label, icon, color, show, sx }) =>
                show && (
                  <Button
                    key={key}
                    variant="contained"
                    color={color}
                    sx={{
                      ...commonButtonStyle,
                      ...sx,         // 커스텀 색상
                    }}
                    size="small"
                    startIcon={icon}
                    onClick={() => handleClick(key)}
                  >
                    {label}
                  </Button>
                )
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FrameTitle;
